/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, {
  useEffect, useState, Dispatch, SetStateAction,
} from 'react';
import {
  TOOLTIP_DOCUMENT_HUB,
} from 'Utils/Constants';
import {
  maxMobile,
  maxTablet,
  maxWidth,
  maxWidth1300,
  midWidthApp, primaryColor, primaryFont,
  retina,
  scrollbarX, wMedium,
} from 'Utils/utilsStyle';
import {
  Spin, Checkbox,
} from 'antd';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  DocHubCurrentViewType, DocHubEntity, DocHubSortType,
} from 'Types/DocumentHubTypes';
import DocumentHubTableSkeleton from 'Components/common/skeleton/DocumentHubTableSkeleton';
import classNames from 'classnames';
import DownAngleIcon from 'Components/common/assets/svgIcons/DownAngleIcon';
import {
  getCurrentTime, isDocument, valueToObject,
} from 'Utils/UtilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';

import {
  selectDeleteloading,
  selectDownloadLoadingIds,
  selectFileDownloadURL, selectIsSelectAll,
  selectSelectedDocumentsCount,
  selectShowSelected,
  selectDownloading,
  selectError,
  selectRenameId,
  selectSapRadio,
  selectUserItemCount,

} from 'Selector/DocumentHubSelector';
import { useDocumentHubSelection } from 'Utils/hooks/useDocumentHubSelection';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import AddCollaboratorsPopup from 'Components/common/modal/AddCollaboratorsPopup';
import DrawerDocViewer from './DrawerDocViewer';
import DocumentBottomAccordion from './DocumentBottomAccordian';
import DocumentHubTableBody from './DocumentHubTableBody';

const StyledWrapper = styled.div`
&.document-hub-table-wrapper {
  &.onlyFilesWrapper {
    .document-hub-inner-style-wrapper {
      .header-table {
         .table-item {
          &:last-child {
            .heading-div {
              display: none;
            }
          }         
        }
      }
      .table-item {
        &:last-child {
          max-width: 55px;
          min-width: 55px;
        }
      }
    }
  }
  &.withoutCheckboxWrapper {
    .document-hub-inner-style-wrapper {
      .table-width-decide {  
        .header-table {
          &.fileTileHeader {

          }
          .table-item {
            &:first-child {
              padding-left: 0px;
            }
            &:nth-child(2) {
              padding-left: 5px;
            }
          }
        }   
        .table-item {
        &:first-child {
          padding-left: 27px;
          min-width: calc(100% - 742px);
          max-width: calc(100% - 742px);
          @media all and (max-width :${maxWidth}), ${retina} {
            min-width: calc(100% - 654px);
            max-width: calc(100% - 654px);
          }
        }
        &:nth-child(2) {
          min-width: unset !important;
          max-width: unset !important;
          @media all and (max-width :${maxWidth}), ${retina} {
            min-width: unset !important;
            max-width: unset !important;
          }
        }
      } 
      }
    }
  }
  position: relative;
  padding: 10px 0px;
  .document-hub-inner-style-wrapper {
    .table-width-decide {
      @media all and (min-width: 1900px) {
         .table-item {
          flex: 1 1 10%;
          min-width: unset !important;
          max-width: unset !important;
          &:first-child {
            min-width: 55px !important;
            max-width: 55px !important;
          }
          &:nth-child(2) {
            flex: 1 1 40%;
          }
         }
      }
      @media all and (max-width: ${midWidthApp}) {
        min-width: calc(100vw + 50px);
      }
      .header-table {
        .table-item {
          &:nth-child(2) {
            padding-left: 63px;
          }
        }
      }
      .infinite-scroll-component__outerdiv {
        .infinite-scroll-component {
          &.infinite-document-hub {
            position: relative;
            z-index: 0;
          }
          display: flex;
          flex-direction: column;
          padding: 15px 30px 5px; //first tile issue
          min-height: calc(100vh - 310px);
          overflow-y: hidden !important;
          @media all and (max-width: ${maxMobile}) {
            padding: 15px 5px 5px;
          }
          &.forLoader {
            min-height: unset;
          }
          .body-table {
            border: 2px solid #fff;
            &.activeDrawer {
              border: 2px solid ${primaryColor};
            }
            &.active {
              border: 2px solid ${primaryColor};
              background: #ECFAF1;
            }
          }
          .ant-popover {
            .ant-popover-content {
              .ant-popover-inner {
                padding: 12px 15px;
              }
            }
          }
        }
      }
    }
  }
  /* .fileTileBody {
    .table-item {
      &:last-child {
        min-width: 55px;
        max-width: 55px;
      }
    }
  } */
  .table-item {
    flex: 1 1 0%;
    &:first-child {
      min-width: 55px;
      max-width: 55px;
      &.searchTableWidth {
        display: none;
      }
      @media all and (max-width :${maxWidth}), ${retina} {
        min-width: 55px;
        max-width: 55px;
      }
    }
    &:nth-child(2) {
      min-width: calc(100% - 820px);
      max-width: calc(100% - 820px);
      @media all and (max-width :${maxWidth}), ${retina} {
        min-width: calc(100% - 700px);
        max-width: calc(100% - 700px);
      }
    }
    .ant-checkbox-wrapper {
      &.ant-checkbox-wrapper-checked {
        .ant-checkbox-checked {
          .ant-checkbox-inner {
            border: 2px solid ${primaryColor};
            background-color: #ECFAF1;
          }
        }
      }
      margin-bottom: 0px;
      margin-left: 19px;
      :hover {
        .ant-checkbox {
          .ant-checkbox-inner {
            border-color: rgb(195, 195, 195);
          }
        }
      }
    }
    .table-item-file-name {
      padding-left: 0px;
    }
  } 
}  
  `;

const InnerStyleWrapper = styled.div`
  @media all and (max-width: ${midWidthApp}) { 
    overflow-x: scroll;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    ${scrollbarX};
    padding: 0 10px;
    .table-item {
      @media all and (max-width: ${maxTablet}) {
        min-width: 200px;
        &:first-child {
          min-width: 380px;
          max-width: 380px;
        }
      }
    }
  }
`;
const InnerTable = styled.div``;

const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 30px;
  border: 2px solid rgb(255, 255, 255);
  @media all and (max-width: ${maxMobile}) {
    padding: 0px 5px;
  }
  .table-item {
    position: relative;
    padding: 10px 5px;
    &:first-child {
      .heading-div {
        padding-left: 88px;
      }
    }
    .heading-div {
      &.actionHeading {
        cursor: pointer;
        width: fit-content;
      }
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .global-tooltip-element {
        .section-detail-tip {
          width: 12px;
          height: 12px;
          margin-left: 0;
          margin-right: 8px;
          .info-icon-two {
            width: 12px;
            height: 12px;
          }
          .ant-tooltip {
            .ant-tooltip-content {
              @media all and (max-width: ${maxWidth}), ${retina} { 
                width: 250px;
                min-width: 250px;
              }
              @media all and (max-width: ${maxWidth1300}) {
                width: 200px;
                min-width: 200px;
              }
            }
          }
        }
      }
      .heading-text {
        cursor: pointer;
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMedium};
        line-height: 18px;
        letter-spacing: -0.333px;
        color: #5E7079;
        margin-bottom: 0px;
      }
      .action-div {
        display: flex;
        flex-direction: column;
        margin-left: 5px;
        svg {
          width: 8px;
          height: 8px;
          cursor: pointer;
          &:first-child {
            transform: rotate(180deg);
            margin-bottom: 1px;
          }
        }
      }
    }
  }
  `;

type Props = {
  entities: DocHubEntity[]
  entitiesLoading: boolean
  entitiesEnded: boolean
  fetchMore: (a: DocHubCurrentViewType) => void;
  onDownload: (link: string) => void;
  onSort: (type: string) => void;
  sort: DocHubSortType;
  moveToFolderWrapper?: boolean;
  drawerOpen: boolean;
  setDrawerOpenForDoc: Dispatch<SetStateAction<boolean>>;
  previewDocument: string;
  inSmartDrawer: boolean;
  hideCheckbox: boolean
  inGlobalSearch?: boolean
  currentView: DocHubCurrentViewType
  isFolderSelected: boolean
  setDeletePopupVisible: (a: boolean) => void;
} & typeof defaultProps;

const defaultProps = {
  inGlobalSearch: false,
  moveToFolderWrapper: false,
};

const DocumentHubTable = function DocumentHubTable(props: Props) {
  const {
    entities, entitiesEnded, entitiesLoading, fetchMore,
    onDownload,
    onSort, sort,
    drawerOpen, setDrawerOpenForDoc, previewDocument,
    hideCheckbox, inSmartDrawer,
    moveToFolderWrapper, inGlobalSearch,
    currentView, isFolderSelected, setDeletePopupVisible,
  } = props;

  const tableHeader = [
    {
      title: 'Name',
      type: 'name',
      sortType: 'name',
    },
    {
      title: !inSmartDrawer ? 'Created by' : 'Uploaded by',
      type: currentView === 'folder' ? 'createdBy' : 'uploadedBy',
      sortType: currentView === 'folder' || currentView === 'both' ? 'createdBy' : 'uploadedBy',
    },
    {
      title: inSmartDrawer ? 'Uploaded on' : 'Last modified',
      type: 'date',
      sortType: 'lastModified',
    },
    ...(currentView === 'folder' || currentView === 'both' ? [{
      title: 'Include in Gilroy',
      type: 'includeInGilroy',
      sortType: 'gilroyToggle',
    }] : [{
      title: '',
      type: 'menu',
      sortType: 'menu',
    }]),
  ];

  const {
    handleCheckAll, handleCheckBoxClick,
    isHeaderCheckboxChecked,
  } = useDocumentHubSelection(inSmartDrawer ? 'sap' : '');

  const downloadLoading = useSelector(selectDownloadLoadingIds);
  const downloadURL = useSelector(selectFileDownloadURL);
  const deleteLoading = useSelector(selectDeleteloading);
  const selectedDocumentCount = useSelector(selectSelectedDocumentsCount);
  const isSelectAll = useSelector(selectIsSelectAll);
  const showSelected = useSelector(selectShowSelected);
  const downloading = useSelector(selectDownloading);
  const error = useSelector(selectError);
  const renameId = useSelector(selectRenameId);
  const sapRadio = useSelector(selectSapRadio);
  const [tableRowId, setTableRowId] = useState<number | null>();
  const userItemCount = useSelector(selectUserItemCount);

  const disableSelectAll = !entities.length || !userItemCount;

  const dispatch = useDispatch();
  const startTime = getCurrentTime();

  useEffect(() => {
    if (downloadURL) {
      onDownload(downloadURL);
      dispatch(actions.toggleDocumentPopover(0));
    }
  }, [downloadURL]);

  useEffect(() => {
    const node = document.querySelector('body');
    return ((selectedDocumentCount > 0) && !inSmartDrawer) ? node?.classList.add('body-document-accordion') : node?.classList.remove('body-document-accordion');
  }, [selectedDocumentCount]);

  const handleMultipleDocumentsDelete = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('clicked_deleteMultiplefiles_documentHub', startTime, {}),
    ));
    setDeletePopupVisible(true);
  };

  const clearSelection = () => {
    dispatch(actions.resetSelectedDocuments(inSmartDrawer));
  };
  return (
    <StyledWrapper className={classNames('document-hub-table-wrapper withCheckboxWrapper', {
      withoutCheckboxWrapper: hideCheckbox,
      onlyFilesWrapper: false, // add check here incase all files
    })}
    >
      <InnerStyleWrapper className="document-hub-inner-style-wrapper">
        <InnerTable className="table-width-decide">
          {!inGlobalSearch ? (
            <TableHeader className={classNames('header-table', { folderViewHeaderTable: currentView === 'folder' || currentView === 'both' })}>
              {hideCheckbox ? null : (
                entitiesLoading && (!entities?.length || showSelected)
                  ? (
                    <span className="table-item">
                      <Spin />
                    </span>
                  )
                  : (
                    <span className="table-item">
                      <Checkbox
                        onChange={() => handleCheckAll(false)}
                        checked={isHeaderCheckboxChecked}
                        disabled={!inSmartDrawer ? (deleteLoading || disableSelectAll) : sapRadio === 'document'}
                      />
                    </span>
                  )
              )}
              {tableHeader?.map((heading, index) => (
                <span className="table-item">
                  <div className="heading-div">
                    {index >= 3 && currentView !== 'document' ? (
                      <HeadingWithToolTip
                        toolTipText={TOOLTIP_DOCUMENT_HUB}
                        customWidth="300px"
                      />
                    ) : null}
                    <span
                      className="heading-text"
                      onClick={() => onSort(heading.sortType)}
                      onKeyDown={() => onSort(heading.type)}
                      role="button"
                      tabIndex={0}
                    >
                      {heading.title}
                    </span>
                    {
                      index !== 3 || currentView !== 'document' ? (
                        <div
                          className="action-div"
                          onClick={() => onSort(heading.type)}
                          onKeyDown={() => onSort(heading.type)}
                          role="button"
                          tabIndex={0}
                        >
                          <DownAngleIcon color={sort.includes('asc') && sort.includes(heading.sortType) ? primaryColor : '#5E7079'} />
                          <DownAngleIcon color={sort.includes('desc') && sort.includes(heading.sortType) ? primaryColor : '#5E7079'} />
                        </div>
                      ) : (
                        null
                      )
                    }

                  </div>
                </span>
              ))}
            </TableHeader>
          ) : null}
          {drawerOpen && (
            <DrawerDocViewer
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpenForDoc}
              URL={previewDocument}
              setTableRowId={setTableRowId}
            />
          )}
          <InfiniteScroll
            dataLength={entities.length}
            next={() => fetchMore(currentView)}
            hasMore={!entitiesEnded}
            loader={false}
            className={classNames('infinite-document-hub o-x-hidden', { forLoader: entitiesLoading, loaderDrawer: entitiesLoading && inSmartDrawer })}
            height={inSmartDrawer ? 'auto' : ''}
          >
            {
              entities.map((item) => (
                <DocumentHubTableBody
                  type={isDocument(item) ? 'document' : 'folder'}
                  entity={item}
                  tableRowId={tableRowId}
                  drawerOpen={drawerOpen}
                  hideCheckbox={hideCheckbox}
                  inGlobalSearch={inGlobalSearch}
                  moveToFolderWrapper={moveToFolderWrapper}
                  handleCheckBoxClick={handleCheckBoxClick}
                  inSmartDrawer={inSmartDrawer}
                  showSelected={showSelected}
                  loading={entitiesLoading}
                  renameId={renameId}
                  error={error}
                  setError={() => dispatch(actions.setError(false))}
                  downloadLoading={downloadLoading}
                  downloading={downloading}
                  setTableRowId={setTableRowId}
                  setDrawerOpenForDoc={setDrawerOpenForDoc}
                  isSelection={isSelectAll || selectedDocumentCount > 0}
                />
              ))
            }
            {
              entitiesLoading
                && inSmartDrawer ? <DocumentHubTableSkeleton /> : null
            }
          </InfiniteScroll>
          {entitiesLoading && !inSmartDrawer ? <DocumentHubTableSkeleton /> : null}
        </InnerTable>
        {
          inSmartDrawer ? null
            : (
              <DocumentBottomAccordion
                drawerVisible={selectedDocumentCount > 0}
                isDeleteButtonDisabled={selectedDocumentCount === 0}
                handleMultipleDocumentsDelete={handleMultipleDocumentsDelete}
                count={selectedDocumentCount}
                clearSelection={clearSelection}
                isFolderSelected={isFolderSelected}
              />
            )
        }
        <AddCollaboratorsPopup />
      </InnerStyleWrapper>
    </StyledWrapper>
  );
};
DocumentHubTable.defaultProps = defaultProps;
export default DocumentHubTable;
